"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _index = require("../../index");
var _InstalmentsBar = require("../InstalmentsBar");
var _hooks = require("../../../helpers/hooks");
var _currency = require("../../../currency");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Bar = function Bar(_ref) {
  var item = _ref.item,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast,
    currency = _ref.currency,
    amountToPayPercentage = _ref.amountToPayPercentage,
    itemColourClassName = _ref.itemColourClassName,
    showCurrency = _ref.showCurrency;
  var key = (0, _hooks.useKeyHack)();
  var isFullWidth = item.width === 100;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, isFirst && !!amountToPayPercentage && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute height-100% d8-u-warning-bg d8-u-zindex-header",
    style: {
      width: "".concat(amountToPayPercentage, "%"),
      left: "".concat(item.status !== 'paid' ? '0' : item.width, "%")
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: generateClassNames(isFirst, isLast, isFullWidth, itemColourClassName),
    style: {
      width: "".concat(item.width, "%"),
      borderRight: !isLast && '2px solid white'
    }
  }, /*#__PURE__*/_react["default"].createElement(_index.Tooltip, {
    key: key,
    content: /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-left"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-md d8-u-text-bold d8-u-capitalize"
    }, item.tooltipTitle), /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-text-bold"
    }, /*#__PURE__*/_react["default"].createElement(_currency.FormatCurrency, {
      amount: item.amount,
      baseCurrency: currency,
      showCurrency: showCurrency
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-color-contrast-lower text-sm"
    }, item.dueDate ? "Due ".concat((0, _moment["default"])(item.dueDate).format('D MMM Y')) : '')),
    className: "width-100% height-100% inline-block margin-bottom-md",
    theme: (0, _InstalmentsBar.getTooltipTheme)(itemColourClassName),
    arrow: false,
    interactive: true
  })));
};
var generateClassNames = function generateClassNames(isFirst, isLast, isFullWidth, itemColourClassName) {
  var classNames = "".concat(itemColourClassName, " position-relative height-100%");
  if (isFirst) classNames = "".concat(classNames, " ").concat(isFullWidth ? 'd8-u-radius-md' : 'd8-u-radius-md-left');
  if (isLast) classNames = "".concat(classNames, " d8-u-radius-md-right");
  return classNames;
};
Bar.propTypes = {
  item: _propTypes["default"].object.isRequired,
  isFirst: _propTypes["default"].bool.isRequired,
  isLast: _propTypes["default"].bool.isRequired,
  currency: _propTypes["default"].string.isRequired,
  showCurrency: _propTypes["default"].string,
  itemColourClassName: _propTypes["default"].string.isRequired,
  amountToPayPercentage: _propTypes["default"].number
};
var _default = exports["default"] = Bar;